import { action } from '@storybook/addon-actions';
import { Meta, StoryObj } from '@storybook/react';

import { PaginationButton } from './PaginationButton';

const meta: Meta<typeof PaginationButton> = {
  title: 'parts/link button/PaginationButton',
  component: PaginationButton,
  args: {
    onClick: action('click'),
    variant: 'next',
    disabled: false,
  },
};

export default meta;

type Story = StoryObj<typeof PaginationButton>;

export const Basic: Story = {
  render: args => <PaginationButton {...args} />,
};
